/**
 * Los adaptadores al BFF (GuardarContacto*) atrapan el error de Axios y lo
 * DEVUELVEN en vez de relanzarlo. Un resultado sin `data` es un envío fallido.
 * `api_data.ok === false` se considera falla por defensa (hoy el BFF responde
 * 4xx/502 en ese caso, no 200).
 */
export const esLeadFallido = (response: any): boolean =>
    !response?.data || response.data.api_data?.ok === false;
